<template>
    <div>

        <b-form @submit.prevent="onHandleStore" data-vv-scope="formConfigurationCountry">

            <b-row>

                <!-- Países -->
                <b-col md="6" sm="12">
                    <b-form-group>
                        <label for="country_id" class="font-weight-bold">Seleccionar País (*)</label>
                        <el-select v-model="modalCountry.data.country_id" filterable clearable
                            no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                            id="country_id" name="country_id" data-vv-as=" " v-validate="'required'">
                            <el-option v-for="country in countries" :key="country.id"
                                :label="`${country.name} (${country.code})`" :value="country.id">
                            </el-option>
                        </el-select>
                        <div class="text-danger span-error small"
                            v-text="errors.first('formConfigurationCountry.country_id')" />
                    </b-form-group>
                </b-col>

                <!-- Tipo de documento requerido  -->
                <b-col md="6" sm="12" class="font-weight-bold">
                    <b-form-group>
                        <label for="type_documents">Tipo de documento (*)</label>
                       
                        <el-select v-model="modalCountry.data.type_documents" clearable multiple :rows="3" :max-rows="6"
                            name="type_documents" id="type_documents" data-vv-as=" " v-validate="'required'">
                            
                            <el-option v-for="typeDocument in typeDocuments" :key="typeDocument.value"
                                :label="typeDocument.text" :value="typeDocument.value">
                            </el-option>
                        </el-select>
                        <div class="text-danger span-error small"
                            v-text="errors.first('formConfigurationCountry.type_documents')" />
                    </b-form-group>
                </b-col>

                <!-- Idiomas -->
                <b-col cols="12">
                    <div class="border border-color-gray rounded p-3">

                        <h5><strong>Idiomas del País (*)</strong></h5>
                        <div>
                            <b-row class="w-100 m-0">
                                <b-col cols="12"><span>Idiomas disponibles</span></b-col>
                                <b-col md="4" sm="6" v-for="language in availableLanguages" :key="language.id"
                                    @click="() => onHandlePlusLanguage(language)">
                                    <div class="d-flex align-items-center justify-content-between px-4 py-2 rounded border border-color-gray cursor-pointer"
                                        :class="`${isAssignedLanguage(language) ? 'bg-dark text-white font-weight-bold' : ''}`">
                                        <div>
                                            <i class="fa fa-plus mr-2"></i>
                                            {{ `${language.name} [${language.code}]` }}
                                        </div>
                                        <i v-show="isAssignedLanguage(language)" class="fa fa-check"></i>
                                    </div>
                                </b-col>
                            </b-row>
                            <br />
                            <b-row class="w-100 m-0">
                                <b-col cols="12"><span>Idiomas asignados (*)</span></b-col>
                                <b-col cols="12" v-for="(language, index) in modalCountry.data.assignedLanguages"
                                    :key="language.id" class="mb-1">
                                    <div
                                        class="p-3 rounded border border-color-gray d-flex justify-content-between align-items-center d-flex-wrap">
                                        <div>
                                            {{ `${language.name} [${language.code}]` }}
                                            <b-badge variant="dark" class="p-2">{{ language.is_native ? 'Nativo' : ''
                                                }}</b-badge>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <b-form-checkbox size="sm"
                                                v-model="modalCountry.data.assignedLanguages[index].is_native"
                                                name="check-button" switch :value="true" :unchecked-value="false">
                                                Nativo
                                            </b-form-checkbox>
                                            <i @click="() => onHandlePlusLanguage(language)"
                                                class="fa fa-close ml-3 cursor-pointer"
                                                :style="{ fontSize: '20px' }"></i>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>

                    </div>
                </b-col>

                <!-- Nombres personalizados para tipos de documento -->
                <b-col cols="12" v-if="modalCountry.data.type_documents && modalCountry.data.type_documents.length > 0">
                    <div class="border border-color-gray rounded p-3 mt-3">
                        <h5><strong>Nombres Personalizados por Tipo de Documento</strong></h5>
                        <p class="text-muted small">Ingrese un nombre personalizado para cada tipo de documento seleccionado (máximo 10 caracteres, opcional)</p>
                        <b-alert show variant="info" class="py-1 px-2 mb-2 small">
                            <i class="fa fa-info-circle mr-1"></i> Marque el tipo de documento que aplica para evaluar el cumplimiento del adjunto en este país.
                        </b-alert>
                        
                        <b-row class="w-100 m-0">
                            <b-col md="6" sm="12" v-for="typeDoc in modalCountry.data.type_documents" :key="typeDoc">
                                <b-form-group class="mb-3">
                                    <div class="d-flex align-items-center mb-1">
                                        <b-form-checkbox
                                            v-if="isComplianceType(typeDoc)"
                                            v-model="modalCountry.data.compliance_rule_docs"
                                            :value="typeDoc"
                                            size="sm"
                                        />
                                        <span class="font-weight-bold">{{ getTypeDocumentName(typeDoc) }}</span>
                                    </div>
                                    <label :for="`custom_name_${typeDoc}`" class="sr-only">{{ getTypeDocumentName(typeDoc) }}</label>
                                    <b-form-input 
                                        :id="`custom_name_${typeDoc}`"
                                        :name="`custom_name_${typeDoc}`"
                                        :value="getCustomNameValue(typeDoc)"
                                        @input="updateCustomName(typeDoc, $event)"
                                        placeholder="Nombre personalizado (opcional)"
                                        maxlength="10"
                                        :data-vv-as="getTypeDocumentName(typeDoc)"
                                        v-validate="'max:10'">
                                    </b-form-input>
                                    <div class="text-danger span-error small"
                                        v-text="errors.first(`formConfigurationCountry.custom_name_${typeDoc}`)" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>

                <!-- Tiempo de revisión normativa (años): -->
                <b-col md="6" sm="12" class="mt-3">
                    <b-form-group>
                        <label class="font-weight-bold">Tiempo de revisión normativa (años): (*)</label>
                        <div class="d-flex align-items-center">
                            <b-form-checkbox size="lg" v-model="modalCountry.data.has_regulatory_review" switch data-vv-as=" "
                                v-validate="'required'" :value="true" :unchecked-value="false" name="has_regulatory_review"
                                id="has_regulatory_review" class="mr-3">
                                {{ getStatusApplyReviewTime }}
                            </b-form-checkbox>
                            <div v-if="modalCountry.data.has_regulatory_review" class="d-flex align-items-center">
                                <b-form-input id="regulatory_review_period" name="regulatory_review_period"
                                    v-model="modalCountry.data.regulatory_review_period" type="number" placeholder="5"
                                    class="mr-2" style="width: 100px;" required></b-form-input>
                                <span class="text-muted">años</span>
                            </div>
                        </div>
                    </b-form-group>
                </b-col>

                <!-- ¿Aplica gráfica de regulación? -->
                <b-col md="6" sm="12" class="mt-3">
                    <b-form-group>
                        <label class="font-weight-bold">¿Aplica gráfica de regulación?</label>
                        <div class="d-flex align-items-center">
                            <b-form-checkbox size="lg" v-model="modalCountry.data.show_regulation_chart" switch data-vv-as=" "
                                v-validate="'required'" :value="true" :unchecked-value="false" name="show_regulation_chart"
                                id="show_regulation_chart">
                                {{ getDoesItBelongToOECD }}
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                </b-col>

                <!-- El país no adoptó el SGA: no aplica al país de la versión principal del SGA -->
                <b-col md="6" sm="12" class="mt-3" v-if="!modalCountry.data.is_main_sga_country">
                    <b-form-group>
                        <div class="d-flex align-items-center">
                            <b-form-checkbox size="lg" 
                                v-model="modalCountry.data.has_not_adopted_sga" data-vv-as=" "
                                v-validate="'required'" :value="true" :unchecked-value="false" name="has_not_adopted_sga"
                                id="has_not_adopted_sga" />
                                <span class="font-weight-bold">País que no adoptó el SGA</span>
                        </div>
                    </b-form-group>
                </b-col>

                <!-- Tipos de peligros aplicables -->
                <b-col cols="12" class="mt-3">
                    <b-form-group>
                        <label for="danger_type_ids" class="font-weight-bold">Tipos de peligros aplicables (*)</label>
                        <el-select v-model="modalCountry.data.danger_type_ids" filterable clearable multiple
                            no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                            id="danger_type_ids" name="danger_type_ids" data-vv-as=" " v-validate="'required'">
                            <el-option v-for="dangerType in tiposCas" :key="dangerType.id"
                                :label="dangerType.lista" :value="dangerType.id">
                            </el-option>
                        </el-select>
                        <div class="text-danger span-error small"
                            v-text="errors.first('formConfigurationCountry.danger_type_ids')" />
                    </b-form-group>
                </b-col>

            </b-row>

            <div class="d-flex justify-content-end align-items-center mt-4">
                <b-button class="mr-2" variant="light" @click="onHandleCancel"><i class="fa fa-close"></i>
                    Cancelar</b-button>
                <b-button type="submit" variant="info"><i class="fa fa-save"></i> {{ modalCountry.action === 'CREATE' ?
                    'Crear' : 'Guardar cambios'
                    }}</b-button>
            </div>

        </b-form>
    </div>
</template>

<script>

// Importaciones generales
import { mapState, mapActions, mapMutations } from "vuex";

export default {

    name: "AdministrationCountriesForm",

    async mounted() {

        await this.loadCountries(0);
        await this.getTypeDocuments();
        await this.getAvailableLanguages()
        await this.listarTipoCas()
    },

    computed: {

        // Estados para el modulo de administración de Países
        ...mapState('AdministrationCountries', [
            'modalCountry',
            'tableConfig'
        ]),

        // Estados para el modulo del Países
        ...mapState('countries', [
            'countries'
        ]),

        // Estados para el modulo del Adjuntos
        ...mapState('adjuntos', {
            typeDocuments: 'tipos'
        }),

        // Estados para el modulo del Sga
        ...mapState('sgaLanguages', {
            availableLanguages: 'activeLanguages'
        }),

        // Estados para el modulo del Cas
        ...mapState('nuevocas', {
            tiposCas: 'tiposCas'
        }),

        getStatusApplyReviewTime() {
            return this.modalCountry.data.has_regulatory_review ? 'Aplica tiempo' : 'No aplica tiempo'
        },

        getDoesItBelongToOECD() {
            return this.modalCountry.data.show_regulation_chart ? 'Si' : 'No'
        }

    },
    watch: {
        'modalCountry.data.type_documents': function (newArray, oldArray) {
            if (!oldArray || newArray.length >= oldArray.length) return;

            const removedDocTypes = oldArray.filter(docId => !newArray.includes(docId));
            
            if (removedDocTypes.length > 0 && this.modalCountry.data.compliance_rule_docs) {
                const updatedComplianceDocs = this.modalCountry.data.compliance_rule_docs.filter(
                    ruleDocId => !removedDocTypes.includes(ruleDocId)
                );
                
                if (updatedComplianceDocs.length !== this.modalCountry.data.compliance_rule_docs.length) {
                    this.setCountry({
                        ...this.modalCountry.data,
                        compliance_rule_docs: updatedComplianceDocs
                    });
                }
            }
        }
    },
    methods: {

        // Mutaciones para el modulo de Administración de países
        ...mapMutations('AdministrationCountries', [
            'resetCountry',
            'setAction',
            'setCountry'
        ]),

        // Métodos del modulo de Administración de países
        ...mapActions('AdministrationCountries', [
            'actionSave',
            'getAll'
        ]),

        // Métodos del modulo Países
        ...mapActions('countries', [
            'loadCountries'
        ]),

        // Métodos del modulo Adjuntos
        ...mapActions('adjuntos', {
            getTypeDocuments: 'getTipo'
        }),

        // Métodos del modulo Sga
        ...mapActions('sgaLanguages', {
            getAvailableLanguages: 'getActiveLanguagesSga'
        }),

        // Métodos del modulo Cas
        ...mapActions('nuevocas',[
            'listarTipoCas'
        ]),

        /**
         * Obtener el nombre del tipo de documento
         * @param {Number} typeDocValue 
         */
        getTypeDocumentName(typeDocValue) {
            const typeDoc = this.typeDocuments.find(td => td.value == typeDocValue);
            return typeDoc ? typeDoc.text : `Tipo ${typeDocValue}`;
        },

        isComplianceType(typeDocValue) {
            const typeDoc = this.typeDocuments.find(td => td.value == typeDocValue);
            return typeDoc && ['FDS', 'MSDS', 'CNP'].includes(typeDoc.codigo);
        },

        /**
         * Obtener el valor del nombre personalizado para un tipo de documento
         * @param {Number} typeDocValue 
         */
        getCustomNameValue(typeDocValue) {
            const customName = this.modalCountry.data.custom_names.find(cn => cn.type_document_id == typeDocValue);
            return customName ? customName.custom_name : '';
        },

        /**
         * Verificar si el lenguaje esta asignado.
         * @param Object language 
         */
        isAssignedLanguage(language) {
            return this.modalCountry.data.assignedLanguages.find(x => x.id === language.id) ? true : false
        },

        /**
         * Actualizar el nombre personalizado para un tipo de documento
         * @param {Number} typeDocValue 
         * @param {String} customName 
         */
        updateCustomName(typeDocValue, customName) {
            let customNames = [...this.modalCountry.data.custom_names];
            
            // Buscar si ya existe un registro para este tipo de documento
            const existingIndex = customNames.findIndex(cn => cn.type_document_id === typeDocValue);
            
            if (customName && customName.trim() !== '') {
                // Si hay un valor, agregar o actualizar
                if (existingIndex >= 0) {
                    customNames[existingIndex].custom_name = customName.trim();
                } else {
                    customNames.push({
                        type_document_id: parseInt(typeDocValue), // Asegurar que sea número
                        custom_name: customName.trim()
                    });
                }
            } else {
                // Si está vacío, eliminar el registro si existe
                if (existingIndex >= 0) {
                    customNames.splice(existingIndex, 1);
                }
            }
            
            this.setCountry({
                ...this.modalCountry.data,
                custom_names: customNames
            });
        },

        /**
         * Agregar/eliminar país al listado de asignados.
         * @param Object language 
         */
        onHandlePlusLanguage(language) {

            const exist = this.modalCountry.data.assignedLanguages.find(x => x.id === language.id)
            if (exist) {
                this.setCountry({
                    ...this.modalCountry.data,
                    assignedLanguages: this.modalCountry.data.assignedLanguages.filter(x => x.id !== language.id)
                });
            }
            else {
                this.setCountry({
                    ...this.modalCountry.data,
                    assignedLanguages: [...this.modalCountry.data.assignedLanguages, {...language, is_native: this.modalCountry.data.assignedLanguages.length <= 0 ? true : false }]
                });
            }

        },

        // Guardar datos del País.
        async onHandleStore() {

            if (this.modalCountry.action === 'EDIT' && !this.modalCountry.data.id) {
                this.$alertError("La configuración del País esta presentando problemas.");
                return
            }

            if (!this.modalCountry.data.assignedLanguages || typeof this.modalCountry.data.assignedLanguages !== 'object' || this.modalCountry.data.assignedLanguages.length <= 0) {
                this.$alertError("Debes seleccionar por lo menos un lenguaje para el País.");
                return
            }

            const languages = this.modalCountry.data.assignedLanguages.map(x => ({ id: x.id, is_native: x.is_native }))
            if (!languages.find(x => x.is_native === true)) {
                this.$alertError("Debes indicar que unos de los Países seleccionados es Nativo.");
                return
            }

            this.setCountry({
                ...this.modalCountry.data,
                languages
            });

            this.$validator.validateAll('formConfigurationCountry')
                .then(async (result) => {
                    if (!result) return

                    const payload = {
                        ...this.modalCountry.data,
                        action: this.modalCountry.action,
                        callback: this.callbackCreate
                    }

                    await this.actionSave(payload)
                });
        },

        async callbackCreate(status) {
            if (!status) return

            this.onHandleCancel()
            await this.getAll({ page: this.tableConfig.dataFields.current_page, per_page: this.tableConfig.dataFields.per_page })
        },

        // Cancelar acciones.
        onHandleCancel() {
            this.resetCountry();
            this.setAction('CREATE');
            this.$bvModal.hide(this.modalCountry.id);
        },

    }
};
</script>

<style scoped>
.vue-treeselect__menu-container {
    font-weight: 200 !important;
}
</style>
